import Swiper from 'swiper';
import { Grid } from 'swiper/modules';

function sliderOtherTeachers() {
  new Swiper('.swiper-other-teachers', {
    modules: [Grid],
    spaceBetween: 8,
    grabCursor: true,
    slidesPerView: 1.5,
    breakpoints: {
      600: {
        spaceBetween: 8,
        slidesPerView: 3,
      },
      1110: {
        spaceBetween: 34,
        slidesPerView: 4,
        grid: {
          fill: "row",
          rows: 3,
        },
      }
    }
  });
}
sliderOtherTeachers();